import { makeStyles } from '@material-ui/core'
import { Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { Button, Toolbar } from 'src/modules/ui'

const useStyles = makeStyles(theme => ({
  form: {
    backgroundColor: theme.palette.fadedPurple.main,
    borderRadius: theme.shape.borderRadius,
  },
  grow: {
    flexGrow: 1,
  },
  submitButton: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('tablet')]: {
      marginBottom: theme.spacing(0),
    },
  },
}))

const FormikTabForm = ({ color, HeaderComponent, tabs, ...props }) => {
  return (
    <Formik {...props}>
      {formik => (
        <>
          {HeaderComponent && <HeaderComponent />}
          <FormikForm {...formik} color={color} tabs={tabs} />
        </>
      )}
    </Formik>
  )
}

const FormikForm = ({
  color,
  errors,
  handleSubmit,
  isSubmitting,
  tabs,
  touched,
}) => {
  const classes = useStyles()
  const assignedFormFields = tabs.reduce((fields, tab) => {
    if (tab.formFields) {
      return [...fields, ...tab.formFields]
    } else {
      return fields
    }
  }, [])
  const formErroredFields = Object.keys(errors).filter(field => touched[field])

  const tabsWithErrors = tabs.map(tab => {
    const { formFields, formRemainingFields } = tab

    let hasError = false
    if (formErroredFields.length > 0) {
      if (formFields) {
        hasError = tab.formFields.some(field =>
          formErroredFields.includes(field)
        )
      } else if (formRemainingFields) {
        hasError = formErroredFields.some(
          field => !assignedFormFields.includes(field)
        )
      }
    }
    return {
      ...tab,
      color: hasError ? 'red' : color,
    }
  })

  return (
    <div className={classes.form}>
      <Toolbar>
        <Toolbar.Tabs color={color} tabs={tabsWithErrors} />
        <div className={classes.grow} />
        <Button
          className={classes.submitButton}
          color="primary"
          isLoading={isSubmitting}
          onClick={handleSubmit}
        >
          Save
        </Button>
      </Toolbar>
      <Switch>
        {tabs.map(route => (
          <Route {...route} id={route.path} key={route.path} />
        ))}
        <Redirect to={tabs[0].path} />
      </Switch>
    </div>
  )
}

FormikTabForm.props = {
  color: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      path: PropTypes.string,
      render: PropTypes.func,
      component: PropTypes.object,
      // List of fields that are in this form
      formFields: PropTypes.arrayOf(PropTypes.string),
      // If true assumes all other fields are in this tab
      formRemainingFields: PropTypes.bool,
    })
  ),
}

FormikTabForm.defaultProps = {
  color: 'purple',
}

export default FormikTabForm
